module.exports = __webpack_public_path__ + "media/images/icon-2-9b86d9b37d19afeab64bd3fd32d5c0e3.svg";